
import { useState, useEffect, ReactNode } from 'react';
import { LanguageContext, Language } from './index';

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider = ({ children }: LanguageProviderProps) => {
  // Initialize from localStorage or default to English
  const [language, setLanguageState] = useState<Language>(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    return (savedLanguage === 'ja' ? 'ja' : 
            savedLanguage === 'es' ? 'es' : 
            savedLanguage === 'zh' ? 'zh' :
            savedLanguage === 'fa' ? 'fa' : 'en') as Language;
  });

  // Save language preference to localStorage when it changes
  const setLanguage = (newLanguage: Language) => {
    setLanguageState(newLanguage);
    localStorage.setItem('preferredLanguage', newLanguage);
  };

  // Set up the language context value
  const contextValue = {
    language,
    setLanguage,
  };

  return <LanguageContext.Provider value={contextValue}>{children}</LanguageContext.Provider>;
};
